import * as React from 'react';
import { InjectedTranslateProps, translate } from 'react-i18next';
import DeleteSmall from 'wix-ui-icons-common/DeleteSmall';
import UserAddSmall from 'wix-ui-icons-common/UserAddSmall';
import DuplicateSmall from 'wix-ui-icons-common/DuplicateSmall';

import {
  RoleTableRowData
} from '../types';
import { withRouter, RouteChildrenProps } from 'react-router';
import { Role } from '../../types/roles';
import * as s from './RolesActions.scss';
import { TableActionCell } from 'wix-style-react';
import { isBookingsStaffMember } from '../../services/roleService';

interface IRolesActions extends InjectedTranslateProps, RouteChildrenProps {
  rowData: RoleTableRowData;
  isOwner: boolean;
  canInvitePeoplePermission: boolean;
  shouldHidePredefinedRolesViewOrDuplicate: boolean;
  isSite?: boolean;

  onRemoveRequest(role: Role): void;
  reportDuplicateAndEditAction(roleId: string): void;
  onInviteRoleClick(id): void;
  onEditOrViewClick(rowData: Partial<RoleTableRowData>): void;
}

class RolesActions extends React.Component<IRolesActions> {

  getPrimaryButton() {
    const { t, rowData, shouldHidePredefinedRolesViewOrDuplicate } = this.props;
    if (shouldHidePredefinedRolesViewOrDuplicate && !rowData?.isCustom) {
      return null;
    } else {
      const canEdit = this.shouldDisplayEditAction();
      return {
        dataHook: canEdit ? 'role-actions-edit' : 'role-actions-view',
        text: t(canEdit ? 'list.roleActions.edit' : 'list.roleActions.view'),
        onClick: canEdit ? this.onEdit : this.onView,
      };
    }
  }

  shouldDisplayInviteAction = () => {
    return this.props.isOwner || this.props.canInvitePeoplePermission || this.props.isSite;
  }

  shouldDisplayRemoveAction = () => {
    return this.props.rowData.isCustom && (this.props.isOwner || this.props.isSite);
  }

  shouldDisplayEditAction = () => {
    return this.props.rowData.isCustom && (this.props.isOwner || this.props.isSite);
  }

  shouldDisplayDuplicateAndEditAction = () => {
    const { isOwner, isSite, rowData, shouldHidePredefinedRolesViewOrDuplicate } = this.props;
    if (shouldHidePredefinedRolesViewOrDuplicate && !rowData?.isCustom) {
      return false;
    } else {
      return (isOwner || isSite);
    }
  }

  onEdit = () => {
    const id = this.props.rowData.id;
    this.props.onEditOrViewClick({ id, isCustom: true });
  }

  onView = () => {
    const id = this.props.rowData.id;
    this.props.onEditOrViewClick({ id, isCustom: false });
  }

  onRemove = () => {
    return this.props.onRemoveRequest(this.props.rowData);
  }

  onInvite = () => {
    const id = this.props.rowData.id;
    this.props.onInviteRoleClick(id);
  }

  onDuplicateAndEdit = () => {
    const id = this.props.rowData.id;
    this.props.history.push(`/role/new?duplicateId=${id}`, { origin: '/roles' });
    this.props.reportDuplicateAndEditAction(id);
  }

  render() {
    const { t, rowData } = this.props;

    const primaryAction = this.getPrimaryButton();

    const actions = [
      ...(this.shouldDisplayInviteAction() ? [{
        dataHook: 'role-actions-invite',
        text: t('list.roleActions.invite'),
        icon: <UserAddSmall className={s.secondaryIcon} />,
        onClick: this.onInvite,
        disabled: isBookingsStaffMember(rowData.id),
        loading: true,
      }] : []),
      ...(this.shouldDisplayInviteAction() && (this.shouldDisplayDuplicateAndEditAction() || this.shouldDisplayRemoveAction()) ? [{
        divider: true
      }] : []),
      ...(this.shouldDisplayDuplicateAndEditAction() ? [{
        dataHook: 'duplicate-and-edit',
        text: t('list.roleActions.duplicateAndEdit'),
        icon: <DuplicateSmall className={s.secondaryIcon} />,
        onClick: this.onDuplicateAndEdit,
      }] : []),
      ...(this.shouldDisplayRemoveAction() ? [{
        dataHook: 'delete',
        text: t('list.roleActions.delete'),
        icon: <DeleteSmall className={s.secondaryIcon} />,
        onClick: this.onRemove,
      }] : [])
    ];

    return (
      <TableActionCell
        dataHook="roles-actions"
        popoverMenuProps={{ placement: 'left' }}
        secondaryActions={actions as any}
        primaryAction={primaryAction}
      />
    );
  }
}

export default withRouter(translate()(RolesActions));
